<template>
  <section :class="`document-picker-component ${customClasses}`">
    <el-card
      class="documents box-card"
      :body-style="{
        display: selectedDocuments.length > 0 ? '' : 'none'
      }"
    >
      <div slot="header" class="clearfix">
        <div>
          <span class="documents__title">
            Document Selector
          </span>
          <hr class="" />
        </div>

        <!-- <span>Card name</span> -->
        <!-- <el-button style="float: right; padding: 3px 0" type="text">
          Operation button
        </el-button> -->

        <!-- Cascader -->
        <!-- <div class="block">
          <el-cascader
            v-model="dropdownValue"
            :options="dropdownOptions"
            :props="{ expandTrigger: 'hover' }"
            @change="handleDropdownChange"
            class="w-100"
            :filterable="true"
          ></el-cascader>
        </div> -->

        <!-- Select Dropdown -->
        <el-select
          v-model="selectedDropdownDoc"
          placeholder="Select"
          class="document-picker-component__select w-100"
          popper-class="document-picker-component__popper"
          :multiple="true"
          :collapse-tags="true"
          @change="handleDropdownChange"
          @remove-tag="handleDropdownRemove"
        >
          <el-option-group
            v-for="(group, group_i) in dropdownDocuments"
            :key="group.label"
            :label="group.label"
          >
            <el-option
              v-for="(item, item_i) in group.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :class="item.doc.selected ? 'selected' : ''"
              @change="handleDropdownChange"
            >
              <!-- <span style="float: left">{{ item.label }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">
                {{ item.value }}
              </span> -->

              <div
                :class="[
                  'document-picker-component__select__option',
                  { shaded: item_i % 2 === 0 }
                ]"
                :style="{ maxWidth: '600px' }"
                @click="handleDropdownClick(item.doc)"
              >
                <div class="row mw-50">
                  <!-- prettier-ignore -->
                  <!-- <div class="col text-truncate">{{ item.doc.file_name | trim }}</div> -->
                  <!-- prettier-ignore -->
                  <div class="col-9 text-truncate">{{ item.doc.document_type ? item.doc.document_type.name : '' }}</div>
                  <div class="col-3 text-truncate text-right">
                    <div v-html="hashIcon(item.doc)"></div>
                    <!-- <img
                      :src="hashIcon(item.doc)"
                      :alt="item.doc.document_type"
                      width="30"
                    /> -->
                  </div>
                </div>
                <div class="row">
                  <!-- prettier-ignore -->
                  <div class="col meta"><span class="title text-truncate">Name: </span>{{ item.doc.file_name | trim }}</div>
                  <!-- prettier-ignore -->
                  <!-- <div class="col-6 meta">
                    <el-tag class="my-1" size="mini" type="info" effect="plain">
                      {{ item.doc.document_type ? item.doc.document_type.name : '' }}
                    </el-tag>
                  </div> -->
                </div>
                <div class="row">
                  <!-- prettier-ignore -->
                  <!-- <div class="col-6 meta"><span class="title">Name: </span>{{ item.doc.file_name | trim }}</div> -->
                  <!-- prettier-ignore -->
                  <!-- <div class="col-6 meta"><span class="title text-truncate">Author: </span>{{ item.doc && item.doc.applicant ? item.doc.applicant.full_name : '?' }}</div> -->
                  <div class="col-6 meta"><span class="title text-truncate">Author: </span>{{ item.doc.uploader_name }}</div>
                  <!-- prettier-ignore -->
                  <div class="col-6 meta text-right">
                    <el-tag v-if="preSelectedDocs.includes(item.doc.id)"
                      type="danger"
                      size="mini"
                      style="font-size: 10px;">Required</el-tag>
                  </div>
                  <!-- prettier-ignore -->
                  <div class="col-6 meta"><span class="title text-truncate">Size: </span>{{ (item.doc.file_size / 1024).toFixed(2) }} KB</div>
                  <!-- prettier-ignore -->
                  <div class="col-6 meta"><span class="title text-truncate">Created: </span>{{ (item.doc.created_at + "Z") | moment("DD/MM/YYYY hh:mm:ss A") }}</div>
                </div>
              </div>
            </el-option>
          </el-option-group>
        </el-select>

        <!-- Search -->
        <!-- <el-input
          placeholder="Search for documents..."
          v-model="searchInput"
        ></el-input> -->
      </div>

      <!-- <section v-if="requiredDocuments.length > 0" class="border rounded bg-light-OFF p-3 mb-3">
        <div class="row text-muted">
          <label class="col-12">Required Documents</label>
        </div>
        <div v-for="(document, i) in requiredDocuments" class="row text-muted mt-2">
          <div class="col-12">{{ document.name }}</div>
        </div>
      </section> -->

      <el-alert
        v-if="requiredDocuments.length > 0"
        type="info"
        :closable="false"
        class="mb-3 py-3"
        title="Required Documents"
        show-icon
      >
        <!-- <div class="row text-muted">
          <label class="col-12">Required Documents</label>
        </div> -->
        <div v-for="(document, i) in requiredDocuments" class="row text-muted">
          <div class="col-12" style="font-size: 12px;">{{ document.name }}</div>
        </div>
      </el-alert>

      <el-alert
        v-if="showPreselectedDocsMessage"
        title="Required documents have been pre-selected for you."
        type="success"
        :closable="false"
        :class="'mb-3'"
      ></el-alert>

      <!-- Accordion -->
      <section v-if="accordion">
        <el-collapse v-model="activeAccordionNames">
          <el-collapse-item
            v-for="(docs, typeId) in groupedDocuments"
            :key="typeId"
            :name="typeId"
          >
            <template slot="title">
              {{ typeId }}
            </template>
            <section
              :key="i"
              v-for="(doc, i) in docs"
              v-if="isDocumentSelected(doc)"
              :class="['documents__list', i === 0 ? 'mt-0' : 'mt-3']"
            >
              <DocumentCard
                :doc="doc"
                :selected="isDocumentSelected(doc)"
                @click="handleDocumentCardClick(doc)"
              />
            </section>
          </el-collapse-item>
        </el-collapse>
      </section>
      <!-- Documents List -->
      <section v-else>
        <section
          :key="i"
          v-for="(doc, i) in docs.filter(e => e.selected)"
          :class="['documents__list', i === 0 ? 'mt-0' : 'mt-3']"
        >
          <DocumentCard
            :doc="doc"
            :selected="isDocumentSelected(doc)"
            @click="handleDocumentCardClick(doc)"
          />
        </section>
      </section>

      <!-- END CARD SECTION -->
    </el-card>
  </section>
</template>

<script>
import _ from "underscore"
import { toSvg } from "jdenticon"

const { data_get } = Ambition.Helpers

import DocumentCard from "./DocumentCard"

export default {
  name: "DocumentPicker",
  components: {
    DocumentCard
  },
  props: {
    docs: { type: Array, default: [] },
    customClasses: { type: String, default: "" },

    // Chosen product
    requiredDocuments: { type: Array, default: () => [] },

    // Switches / Toggles
    accordion: { type: Boolean, default: false }
  },
  data() {
    return {
      // selectedDocsMap: new Set(),

      searchInput: "",
      activeAccordionNames: [],
      selectedDropdownDoc: [],
      preSelectedDocs: [],
      isDropdownTouched: false

      // dropdownValue: [],
      // dropdownOptions: []
    }
  },
  computed: {
    showPreselectedDocsMessage() {
      // return this.selectedDropdownDoc.sort().join() === this.preSelectedDocs.sort().join()
      return this.preSelectedDocs.length > 0 && !this.isDropdownTouched
    },

    selectedDocuments() {
      return this.docs.filter(e => e.selected)
    },

    searchedDocuments() {
      const term = this.searchInput.toLowerCase()

      // If search is empty return all docs
      if (term.length === 0) return this.docs

      return this.docs.filter(doc => {
        if (doc.file_name && doc.file_name.includes(term)) return true
        if (doc.name && doc.name.toLowerCase().includes(term)) return true
        // prettier-ignore
        if (doc.document_type && doc.document_type.document_type && doc.document_type.document_type.toLowerCase().includes(term)) return true
        // prettier-ignore
        if (doc.applicant && doc.applicant.full_name && doc.applicant.full_name.toLowerCase().includes(term)) return true
        return false
      })
    },

    groupedDocuments() {
      let docs = _.groupBy(this.searchedDocuments, e => {
        const type = data_get(e, "document_type.document_type", "other")
        return type.toUpperCase()
      })
      return docs
    },

    dropdownDocuments() {
      return Object.entries(this.groupedDocuments).map((e, i) => {
        let label = e[0]
        let options = e[1].map(doc => {
          const label = Ambition.Helpers.truncateString(doc.file_name, 30)
          return { value: doc.id, label, doc }
        })
        // console.warn("dropdownDocuments", { key, val })
        return { label, options }
      })
    }
  },
  watch: {
    selectedDropdownDoc(newVal, oldVal) {
      newVal.concat(oldVal).forEach(id => {
        const doc = this.docs.find(e => e.id === id)
        const isAdded = newVal.includes(id) // added or removed?
        // console.warn(`DOCUMENT [${doc.id}] was ${isAdded ? 'ADDED': 'REMOVED'}`)
        this.$emit("select", doc, isAdded)
      })
    }
  },
  mounted() {
    // Open all accordion tabs
    this.activeAccordionNames = Object.keys(this.groupedDocuments).map(name => {
      return name
    })

    // console.warn("DOCS", this.selectedDocuments)
    this.selectedDocuments.forEach(e => {
      this.selectedDropdownDoc.push(e.id)
      this.preSelectedDocs.push(e.id)
    })
  },
  updated() {},
  activated() {},
  methods: {
    hashIcon(doc) {
      const uuid = doc.document_type ? doc.document_type.name : "other"
      return toSvg(uuid, 32)
    },

    isDocumentSelected(doc) {
      // Option #1
      // return this.selectedDocsMap ? this.selectedDocsMap.has(doc) : false

      // Option #2
      return doc.selected
    },

    handleDocumentCardClick(doc, index) {
      this.$emit("select", doc)

      this.selectedDropdownDoc = this.selectedDropdownDoc.filter(doc_id => {
        return doc.id === doc_id ? false : true
      })

      // Option #1: using data property to track without mutating doc object
      // if (this.isDocumentSelected(doc)) this.selectedDocsMap.delete(doc)
      // else this.selectedDocsMap.add(doc)

      // Option #2: mutate doc object directly
      // this.docs = this.docs.map(e => {
      //   if (e.id === doc.id) e.selected = !e.selected
      //   return e
      // })
    },

    handleDropdownRemove(doc_id) {
      // console.warn("handleDropdownRemove", doc_id)
    },

    handleDropdownChange(value) {
      if (!this.isDropdownTouched) this.isDropdownTouched = true
      // console.warn("handleDropdownChange", { value, doc })
      // this.selectedDropdownDoc.forEach(doc_id => {
      //   console.warn("handleDropdownChange", doc_id)
      //   this.$emit("select", this.docs.find(e => e.id === doc_id), true)
      // })
    },

    handleDropdownClick(doc) {
      // console.warn("handleDropdownClick", { doc })
      // this.selectedDropdownDoc = ""
      // if (doc) this.$emit("select", doc)
    }

    // loadDocumentTypes() {
    //   let adminUrl = process.env.MIX_APP_URL
    //   Ambition.Request.call({
    //     admin: true,
    //     method: "GET",
    //     url: `${adminUrl}/api/documents`,
    //     data: {}
    //   }).then(response => {
    //     console.warn("TESTING DOCS", response)
    //     // this.$message({ message: 'Save Success!', type: 'success' })
    //   }).catch(error => {
    //     console.warn("TESTING DOCS", error)
    //     // this.$message({ message: 'Save Failed', type: 'error' })
    //   })
    // }
  }
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';

.document-picker-component {
}

.document-picker-component {
  .el-card__header {
    display: none;
  }
}

// Documents
.documents {
}

.documents__title {
  font-weight: 500;
  // color: #fff;
  color: #555;
}
</style>

<style lang="scss">
// @import '@assets/sass/backend/_core-variables.scss';

.document-picker-component {
  .el-card__header {
    // background-color: rgba(#2493ef, 0.125);
    // background-color: rgba(#6c757d, 0.125);
    background-color: rgba(#f9f9f9, 1);
    // border: 1px solid #ebeef5;
  }
  .el-select-group__title {
    // font-size: 12px !important;
  }
  .el-select__tags {
    // display: none;
  }
}

.document-picker-component__popper {
  .el-select-dropdown__wrap {
    max-height: 400px;
  }
  .el-select-group__title {
    background-color: #2493ef;
    color: #fff !important;
    border-bottom: 1px solid #ebeef5;
  }
  .el-select-group__wrap {
    padding-bottom: 0;
    &:not(:last-of-type)::after {
      display: none;
    }
  }
  .el-select-dropdown__list {
    // background-color: #fff;
  }
  .el-select-dropdown__item {
    height: auto;
    line-height: 2.25;
    // height: 68px;
    // line-height: 34px;
    // border: 1px solid red;
    border-bottom: 1px solid #ebeef5;
    padding: 0;
    .document-picker-component__select__option {
      padding: 12px 20px;
      font-size: 0.75rem;
      &:hover {
        cursor: pointer;
      }
    }
    &:not(.hover) .document-picker-component__select__option {
      &.shaded {
        background-color: #f9f9f9;
      }
    }
    .meta {
      font-size: 11px;
    }
    .title {
      font-weight: 600;
    }
    &.selected {
      font-weight: normal;
    }
  }
}
</style>
